import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
const PillBadge = _ref => {
  let {
    children,
    className,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `${styles.container} ${className}`
  }, props), children);
};
process.env.NODE_ENV !== "production" ? PillBadge.propTypes = {
  /**
   * Text to render
   */
  children: PropTypes.node,
  /**
   * Styles to apply
   */
  className: PropTypes.string
} : void 0;
PillBadge.defaultProps = {
  className: '',
  children: ''
};
export default PillBadge;